import { render } from "./ProgramManagement.vue?vue&type=template&id=6bcf1e8a&scoped=true&ts=true"
import script from "./ProgramManagement.vue?vue&type=script&lang=ts"
export * from "./ProgramManagement.vue?vue&type=script&lang=ts"

import "./ProgramManagement.vue?vue&type=style&index=0&id=6bcf1e8a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bcf1e8a"]])

export default __exports__